<template>
  <div>
    <h2 class="content-block">Change Password</h2>
    <div class="content-block dx-card responsive-paddings">
      <form
          action="action"
          @submit.prevent="postData"
        >
        <DxForm :form-data="formData">
          <template #avatar-template="{}">
            <div class="form-avatar" />
          </template>
          <DxGroupItem :col-count="4" css-class="first-group">
            <DxSimpleItem template="avatar-template" />
            <DxGroupItem :col-span="3">
              <DxSimpleItem data-field="FirstName" :editor-options="editorOptions">
                <DxRequiredRule />
              </DxSimpleItem>
              <DxSimpleItem data-field="LastName" :editor-options="editorOptions">
                <DxRequiredRule />
              </DxSimpleItem>
            </DxGroupItem>
          </DxGroupItem>
          <DxGroupItem :col-count="1" css-class="second-group">
           <DxGroupItem>
             <DxSimpleItem :editor-options="checkBoxOptions" editor-type="dxCheckBox"/>
              <DxSimpleItem
               data-field="CurrentPassword"
              :editor-options="passwordOptions">
               <DxRequiredRule />
              </DxSimpleItem>
              <DxSimpleItem
               data-field="NewPassword"
                 :editor-options="passwordOptions">
                 <DxRequiredRule />
              </DxSimpleItem>
              <DxSimpleItem 
              data-field="ConfirmPassword"
                :editorOptions="passwordOptions">
                 <DxCompareRule :comparison-target="passwordComparison" :message="$t('registration.passwordMismatch')" />
                <DxRequiredRule />
              </DxSimpleItem>
            </DxGroupItem>
          </DxGroupItem>
          <DxButtonItem :button-options="buttonOptions" horizontal-alignment="center" />
        </DxForm>
        </form>
    </div>
  </div>
  </template>
  <script>
  import {
    DxForm,
    DxSimpleItem,
    DxButtonItem,
    DxGroupItem,
    DxLabel,
    DxRequiredRule,
    DxCompareRule,
    DxRangeRule,
    DxStringLengthRule,
    DxPatternRule,
    DxEmailRule,
    DxAsyncRule
  } from 'devextreme-vue/form'
  import { DxTextArea } from 'devextreme-vue/text-area'

  import { mapActions, mapState } from 'vuex'
  import { CHANGE_PASSWORD } from "@/store/_actiontypes"
  export default {
    components: {
      DxForm,
      DxTextArea,
      DxGroupItem,
      DxSimpleItem,
      DxButtonItem,
      DxLabel,
      DxRequiredRule,
      DxCompareRule,
      DxRangeRule,
      DxStringLengthRule,
      DxPatternRule,
      DxEmailRule,
      DxAsyncRule
    },
    data() {
      return {
        formData: {},
        editorOptions: {
          disabled: false
        },
        buttonOptions: {
            text: 'Update',
            type: 'normal',
            useSubmitBehavior: true,
        },
        passwordOptions: { visible: true,  mode: 'password' },
        passwordVisibility: false,
        checkBoxOptions: {
          readOnly: true,
          value: true,
          text: 'Change Password ?',
          onValueChanged: (e) => {
            this.passwordVisibility = e.component.option('value');
          },
        },
        phoneOptions: { mask: '+1 (000) 000-0000', disabled: true },
        notesOptions: { height: 140, disabled: true },
      }
    },   
    
    computed: {
      passwordComparison() {
        return this.formData.NewPassword
      },
      ...mapState({
        profile: state => state?.user?.user?.data?.admistration_Details
      }),
    },
  
    created() {
      let profileData = {
        Id_: this.profile?.id,
        UserName: this.profile?.pr_Phone,
        FirstName: this.profile?.pr_First_Name,
        LastName: this.profile?.pr_Last_Name,
        DateRegistered: this.profile?.created_At,
        PhoneNumber: this.profile?.pr_Phone,
        EmailAddress: this.profile?.pr_Email_Address,
        Status: this.profile?.is_Relevant,
        ChangePassword: false
      }
      this.formData = profileData
    },

    methods: {
      ...mapActions("application", [ CHANGE_PASSWORD]),
       postData() {
        this.CHANGE_PASSWORD(this.formData).then(res => {
            this.$toast.success("Password changed successfully.")
            this.$router.push('/login')
          })
          .catch(error => {
            this.$toast.error(error.data.errors.message)  
          })
       }
    },
  }
  </script>
  <style>
  .first-group,
  .second-group {
    padding: 20px;
  }
  
  .second-group {
    background-color: rgba(191, 191, 191, 0.15);
  }
  
  .form-avatar {
    height: 128px;
    width: 128px;
    margin-right: 10px;
    border: 1px solid #d2d3d5;
    border-radius: 50%;
    background-image: url("../assets/default.jpg");
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }
  </style>